export default "__VITE_ASSET__DSDP6Brv__"